export enum KYC_STEPPER_STATUSES {
    COMPLETED = "COMPLETED",
    NOT_STARTED = "NOT_STARTED",
    IN_PROGRESS = 'IN_PROGRESS'
}